module.exports = __webpack_public_path__ + "img/building95-3.974d0936.jpg";